<template>
  <div class="referral-link-wrap celloAnnouncement" @click="openCello">
    <div class="referral-link celloBadge">
      <img src="../../assets/gift.svg" alt="Gift Icon" class="icon-gift" />
      <span v-if="referralRewardDetails">
        {{ $t("referral.get") }}
      </span>
    </div>
  </div>
</template>

<script>
import { handleCelloOpen } from "@/helpers/referral.helper";
import bundleEvents from "@/telemetry/bundleEvents";
import { mapGetters } from "vuex";

export default {
  name: "ReferralLink",
  computed: {
    // Updated to use namespaced getters from the referral module
    ...mapGetters("referral", ["referralRewardDetails"]),
  },
  methods: {
    openCello() {
      bundleEvents.logReferralHookClicked({
        source_hook: "Neo admin panel",
      });

      // Get the translated error message
      const errorMessage = this.$t("somethingWrong");

      handleCelloOpen(this.showToast, errorMessage);
    },
  },
};
</script>

<style scoped>
.referral-link-wrap {
  position: relative;
  display: flex;
  align-self: center;
  margin-right: 24px;
  align-self: center;
  cursor: pointer;
}

.referral-link {
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--tabBgCol);
}

.referral-link span {
  color: inherit;
}

.icon-gift {
  margin: 0px;
  vertical-align: middle;
  margin-right: 4px;
}

@media screen and (max-width: 768px) {
  .referral-link-wrap {
    margin-right: 0;
  }
}
</style>
